export default "__VITE_PUBLIC_ASSET__8591ebeb__"